export const toISOString = (timestamp: number): string => new Date(timestamp * 1000).toISOString();
